import { useCallback } from "react";
import { useTranslation } from "react-i18next";
import { useNavigate, useParams } from "react-router-dom";

import PagesContainer from "../../../components/UI/PagesContainer";
import InsuranceForm from "../NewScheduleFlow/InsuranceForm";

const AddInsurance = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const { t } = useTranslation();

  const handleSuccess = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return (
    <PagesContainer
      title={
        id
          ? t("page.schedules.insurance.addInsurance.edit")
          : t("page.schedules.insurance.addInsurance.add")
      }
    >
      <InsuranceForm
        showIndividualSelect
        requireRuleForCategory={false}
        insuranceId={id}
        onSuccess={handleSuccess}
      />
    </PagesContainer>
  );
};

export default AddInsurance;
